import {
  getGlobalSearchAutoSuggestion,
  getSearchTerm,
} from 'aster-foundation/core/astercore/globalSearch/redux/actions';
import { getDataFromCookie, getDataFromCookieAToB } from 'aster-foundation/core/common/utils/cookieHelper';
import { searchTermInsertion, searchTermProductInsertion } from 'aster-foundation/core/epharmacy/search/redux/actions';
import * as apiActions from 'aster-foundation/core/teleconsultant/search/redux/actions';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useRef, useState } from 'react';
import Autosuggest from 'react-autosuggest';
import Highlighter from 'react-highlight-words';
import { v4 as uuidv4 } from 'uuid';
import { useDispatch, useSelector } from 'react-redux';
import { dataLayerSendEvent } from 'Epharmacy/EpharmacyAnalytics';
import { IC_MODAL_CLOSE_GREY, IC_POM_DELIVERY_ICON_SEARCH, IC_SEARCH, IC_SEARCH_NODATA } from '../../Assets/images';
import EpharmacyContext from '@common/Context/EpharmacyContext';
import HomeCareContext from '@common/Context/HomeCareContext';
import {
  SEARCH_QUERY,
  URL_QUERY,
  doctorNameEncoder,
  errorHandling,
  fetchDataFromAPI,
  getGuestToken,
  getConfigurationActiveValueByName,
  getIsInstoreApp,
  getReferralPageForGA,
  getSearchCategoryIds,
  removeSpacesWithHyphen,
  getImageUrlWithSize,
} from '@common/Utility/common-utils';
import {
  AE_GLOBAL,
  CMS_BUSINESS_UNIT,
  FLAGSMITH_KEYS,
  HOME_CARE_ROUTE,
  ONE_ASTER_CATEGORY,
  ONLINE_PHARMACY_ROUTE,
  POM_PRODUCT_FLAG,
  TELECONSULT_ROUTE,
} from '@common/Utility/constants';
import { sendEventToSmartLook } from '@common/Utility/smartlook';
import { dataLayerSearch } from '../BookAppointment/BookAppointmentAnalytics';
import IsolatedScroll from '../IsolatedScroll/index';
import Loader from '../Loader/Loader';
import { SearchBoxStyled } from './SearchBoxStyled';
import { setSearchObj } from 'Epharmacy/SearchResult/redux/reducer';
import { SCREEN_NAME } from '@common/Constants/analytics';
import { flagsmith } from '@common/Lib/Flagsmith';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';
import { isRTL, useTranslation } from '@common/i18n';
import { getLangCodeFromUrl } from '../../../../i18n';

const SearchBox = (props) => {
  let inputRef = useRef();
  const containerRef = useRef();
  const [suggestions, setSuggestions] = React.useState([]);
  const [noSuggestion, setNoSuggestion] = React.useState(false);
  const [callRecentSearch, setCallRecentSearch] = React.useState(false);
  const [value, setValue] = useState('');
  const [recentSearchItems, setRecentSearchItems] = React.useState(null);
  const recentSearches = useSelector((state) => state?.teleconsultant?.recentSearches?.data?.recentSuggestions);
  const trendingSearches = useSelector((state) => state?.teleconsultant?.topTrendSearches?.data?.trendingSuggestions);
  const [loading, setLoading] = React.useState(false);
  const [trendingSearchItems, setTrendingSearchItems] = React.useState(null);
  const router = useRouter();
  const generateURL = useNavigationURL();
  const userLogin = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry[0]?.resource);
  const guestLogin = useSelector((state) => state?.astercore?.guestAccessToken?.data);
  const dispatch = useDispatch();
  const [isGuest, setIsGuest] = React.useState(null);
  const [iskeydown, setIskeydown] = useState(false);
  const [triggersearchevent, setTriggersearchevent] = useState(true);
  const [enablekeystroke, setEnablekeystroke] = useState(true);
  const [suggestionurl, setSuggestionurl] = useState("");
  const [suggestiontype, setSuggestiotype] = useState([]);
  const [suggestionposition, setSuggestionposition] = useState(0);
  const [currentLang, setCurrentLanguage] = useState('');

  const epharmacyPage = useContext(EpharmacyContext);
  const [isEpharmacyPage, setEpharmacyPage] = useState(epharmacyPage?.epharmacySearch || false);
  const homeCarePage = useContext(HomeCareContext);
  const [isHomeCarePage, setHomeCarePage] = useState(homeCarePage?.homeCareSearch || false);
  const [isTeleConsulation, setIsTeleConsulation] = React.useState(false);
  const [moduleType, setModuleType] = React.useState('');
  const [showMinCharPopup, setShowMinCharPopup] = React.useState(false);
  const [suggestionObj, setSuggestionObj] = React.useState({});
  const deviceId = uuidv4();
  const zoneData = useSelector((state) => state?.app?.userLocationReducer?.zone);
  const pageType = getReferralPageForGA(router?.asPath);
  const screenName = router?.pathname;
  const pomFlag = flagsmith.getValue(FLAGSMITH_KEYS.POM_PRODUCT_FLAG, { json: true });
  const isPomProductFlag = pomFlag?.enabled;
  const t = useTranslation();
  const web_feature_flaging = flagsmith.getValue(FLAGSMITH_KEYS.WEB_FEATURE_FLAGING, {json: true});

const getreferrerPage = () => {
  return props?.referrerPage
      ? props?.referrerPage
      :'Homepage'
}

const getScreenName = () => {
    return (props?.screenName === 'Aster Core Homepage' && !router?.asPath.includes('/faq') && !router?.asPath.includes('/content'))
        ? (router?.asPath?.split('/').pop() === 'brandlisting' ? 'brand listing' : 
           router?.asPath?.split('/').pop() === 'categorylisting' ? 'category listing' :
           router?.route?.split('/').pop().replace(/-/g, ' ') === 'addnewfamilymember' ? 'add family members' :
           router?.route?.split('/').pop().replace(/-/g, ' ') === 'details' ? 'instantgp information' :
           router?.route?.split('/').pop().replace(/-/g, ' ') === 'completeprofile' ? 'complete profile' :
           suggestionObj?.type==="practitioner" || suggestions?.type==="practitioner" ? router?.query?.doctorname :
           'asco homepage')
        : (props?.screenName === 'Aster Core Homepage' && router?.asPath.includes('/faq') && !router?.asPath.includes('/content'))
        ? ('faq' + " " + router?.asPath?.split('/').pop().replace(/-/g, ' '))
        : (props?.screenName === 'Aster Core Homepage' && !router?.asPath.includes('/faq') && router?.asPath.includes('/content'))
        ? (router?.asPath?.split('/').pop().replace(/-/g, ' '))    
        : props?.screenName === 'Epharmacy Homepage' || props?.screenName === CMS_BUSINESS_UNIT.PHARMACY
        ? (router?.query?.slugname ? router?.query?.slugname : 'epharmacy homepage')
        : props?.screenName === 'Product Details'
        ? router?.query?.product[0]?.replace(/-/g, ' ')
        : props?.screenName === 'My Cart'
        ? 'my cart'
        : props?.screenName === 'Product Listing'
        ? ((router?.query?.categories ? router?.query?.categories[0] : router?.query?.brands ? router?.query?.brands[0] + " brand" : "-"))
        : props?.screenName === 'Product Listing Page'
        ? 'pharma search result'
        : props?.screenName === 'Doctor Listing Page'
        ? router?.query?.speciality?.replace(/-/g, ' ')
        : props?.screenName === 'Clinic Detail Page'
        ? router?.query?.facility?.replace(/-/g, ' ')
        : props?.screenName === 'Doctor Details Page'
        ? router?.query?.doctorname?.replace(/-/g, ' ')
        : props?.screenName === 'Tele-consult Homepage'
        ? 'doctor consult homepage'
        : props?.screenName === 'Family Members Page'
        ? 'manage family members'
        : props?.screenName === 'My Orders Page'
        ? 'my orders'
        : props?.screenName === 'Rx Upload'
        ? 'rx upload'
        : props?.screenName === 'Appointment Listing Page'
        ? 'appointments'
        : props?.screenName === 'Clinic Listing Page'
        ? 'clinics listing'
        : props?.screenName === 'Checkout Page'
        ? 'appointment checkout'
        : props?.screenName === 'My Profile Page'
        ? 'my profile'
        : props?.screenName === 'Edit Profile Page'
        ? 'edit profile'
        : props?.screenName === 'Family Members Page'
        ? 'manage family members'
        : props?.screenName === 'BookMarks Page'
        ? (router?.query?.screen === "shopping-list" ? 'wishlist shopping' : 
        (router?.query?.screen === "my-doctor" ? 'wishlist doctor' : 'wishlist all'))
        : props?.screenName === 'Add Insurance Page'
        ? 'add Insurance'
        : props?.screenName === 'Insurance Listing Page'
        ? 'insurance'
        : props?.screenName === 'Settings Page'
        ? 'main settings'               
        : (router?.query?.categories || router?.query?.brands) ? 
        ((router?.query?.categories ? router?.query?.categories[0] + " category" : router?.query?.brands ? router?.query?.brands[0] + " brand" : "-")) 
        : (router?.query?.product?.length > 0) ? props?.screenName :
        ((router?.query?.routename?.replace(/-/g, ' ')) || (router?.route?.split('/').pop().replace(/-/g, ' ')))
};

const getPageType = () => {
  return (props?.screenName === 'Aster Core Homepage' && !router?.asPath.includes('/faq') && !router?.asPath.includes('/content'))
      ? (router?.asPath?.split('/').pop() === 'brandlisting' ? 'brand listing page' : 
         router?.asPath?.split('/').pop() === 'categorylisting' ? 'category listing page' :
         router?.route?.split('/').pop().replace(/-/g, ' ') === 'addnewfamilymember' ? 'profile page' :
         router?.route?.split('/').pop().replace(/-/g, ' ') === 'details' ? 'instantgp page' :
         router?.route?.split('/').pop().replace(/-/g, ' ') === 'completeprofile' ? 'profile page' :
         'homepage')
      : (props?.screenName === 'Aster Core Homepage' && router?.asPath.includes('/faq') && !router?.asPath.includes('/content'))
      ?  'content page' 
      : (props?.screenName === 'Aster Core Homepage' && !router?.asPath.includes('/faq') && router?.asPath.includes('/content'))
      ? 'content page'  
      : props?.screenName === 'Epharmacy Homepage' || props?.screenName === CMS_BUSINESS_UNIT.PHARMACY
      ? (router?.query?.slugname ? 'landing page' : 'homepage')
      : props?.screenName === 'Product Details'
      ? 'product details page'
      : props?.screenName === 'Product Listing'
      ? 'product listing page'
      : props?.screenName === 'Product Listing Page'
      ? 'search result page'
      : props?.screenName === 'Doctor Listing Page'
      ? 'doctor listing page'
      : props?.screenName === 'Clinic Detail Page'
      ? 'clinics details page'
      : props?.screenName === 'Doctor Details Page'
      ? 'doctor details page'
      : props?.screenName === 'Tele-consult Homepage'
      ? 'homepage'
      : props?.screenName === 'Family Members Page'
      ? 'profile page'
      : props?.screenName === 'My Cart'
      ? 'cart page'
      : props?.screenName === 'My Orders Page'
      ? 'order detail page'
      : props?.screenName === 'Rx Upload'
      ? 'rx page'
      : props?.screenName === 'Appointment Listing Page'
      ? 'appointments page'
      : props?.screenName === 'Clinic Listing Page' 
      ? 'clinics listing page'
      : (props?.screenName === 'My Profile Page' || props?.screenName === 'Edit Profile Page' || props?.screenName === 'Family Members Page' || props?.screenName === 'Insurance Listing Page' || props?.screenName === 'Add Insurance Page' || props?.screenName === 'Settings Page' || props?.screenName === 'Notifications Page')
      ? 'profile page'
      : (props?.screenName === 'BookMarks Page' || router?.query?.screen === "shopping-list" || router?.query?.screen === "my-doctor")
      ?  'wishlist page'
      : router?.query?.categories || router?.query?.brands ? 'product listing page' 
      : router?.query?.product?.length > 0 ? "product details page" 
      : props?.screenName?.toLowerCase();
};

const getPageId = () => {
  return props?.screenName === 'Aster Core Homepage'
      ? null
      : props?.screenName === 'Epharmacy Homepage'
      ? null
      : props?.screenName === 'Product Details'
      ? router?.query?.product[1]
      : props?.screenName === 'Product Listing'
      ? ((router?.query?.categories ? router?.query?.categories[1] :router?.query?.brands ? router?.query?.brands[1] : router?.query?.categories[0]))
      : props?.screenName === 'Product Listing Page'
      ? null
      : props?.screenName === 'Doctor Listing Page'
      ? null
      : props?.screenName === 'Clinic Detail Page'
      ? router?.query?.clinic
      : props?.screenName === 'Doctor Details Page'
      ? router?.query?.docID
      : props?.screenName === 'Tele-consult Homepage'
      ? null
      : null;
};

  const getSearchkeywordcount = async () => {
    const accessToken = await getGuestToken(deviceId);
    const context = {
      query: {
        text: value?.replace(SEARCH_QUERY, ''),
      },
    };
    const facetResponse = await fetchDataFromAPI(accessToken, deviceId, context, zoneData);
    return facetResponse;
  };

  const sendNoResultEvents = async (value, props, isEpharmacyPage, isTeleConsulation, isHomeCarePage) => {
    const searchdidyoumeancount = await getSearchkeywordcount();
     const eventObj = {
      searchterm: value,
      myAsterCat: props?.globalSearch
        ? 'asco'
        : isEpharmacyPage
        ? 'epharmacy'
        : isTeleConsulation
        ? 'doctor consult'
        : isHomeCarePage
        ? 'homecare'
        : undefined,
      searchActionType: 'enter key',
      pageId: props?.screenName,
      numOfKeywordRedirects: searchdidyoumeancount?.didYouMeanData?.length ?? 0
    };
    dispatch(setSearchObj({
      searchobj: eventObj
    }));
  };

  const sendNoResultsEventsicon = async (value, props, isEpharmacyPage, isTeleConsulation, isHomeCarePage) => {
    const searchdidyoumeancount = await getSearchkeywordcount();
    const eventObj =  {
      searchterm: value,
      myAsterCat: props?.globalSearch
        ? 'asco'
        : isEpharmacyPage
        ? 'epharmacy'
        : isTeleConsulation
        ? 'doctor consult'
        : isHomeCarePage
        ? 'homecare'
        : undefined,
      searchActionType: 'search icon click',
      pageId: props?.screenName,
      numOfKeywordRedirects: searchdidyoumeancount?.didYouMeanData?.length ?? 0
    };
    dispatch(setSearchObj({
      searchobj: eventObj
    }));
  };
  
  const modifySuggestions = (searchResponse) => {
    const modules = Object.values(searchResponse);
    const modifyData = modules.reduce((acc, module) => {
      if (module?.suggestions?.length) {
        acc.push({
          title: module.displayText,
          suggestions: module.suggestions,
        });
      }
      return acc;
    }, []);

    modifyData.sort((a, b) => (a.priority || 0) - (b.priority || 0));
  
      if (modifyData.length === 0) {
        setNoSuggestion(true);
      }
  
    return modifyData;
  }; 

  const BoldSuggestion = ({ children }) => <span className="highlight">{children}</span>;

  useEffect(() => {
    if(window !== 'undefined') {
      setCurrentLanguage(getLangCodeFromUrl());
    }
  }, []);

  useEffect(() => {
    if (
      router?.query?.search ||
      router?.query?.text ||
      router?.query?.doctorname ||
      (router?.query?.speciality && router?.query?.fromsearch) ||
      (router?.query?.facility && router?.query?.fromsearch) ||
      (router?.query?.detailspage && router?.query?.fromsearch)
    ) {
      const updatedValue = (
        router?.query?.title || router?.query?.search ||
        router?.query?.text || ''
      );
      setValue(updatedValue);
    }
  }, [
    router?.query?.text,
    router?.query?.search,
    router?.query?.doctorname,
    router?.query?.speciality,
    router?.query?.facility,
    router?.query?.detailspage,
  ]);

  useEffect(() => {
    if (router?.pathname?.indexOf(ONLINE_PHARMACY_ROUTE) > -1 || web_feature_flaging?.isKsaUser) {
      setEpharmacyPage(true);
    }
    if (router?.pathname?.indexOf(HOME_CARE_ROUTE) > -1) {
      setHomeCarePage(true);
    }
    if (router?.pathname?.indexOf(TELECONSULT_ROUTE) > -1) {
      setIsTeleConsulation(true);
    }
  }, [router?.pathname]);

  useEffect(() => {
    if (props?.screenName === CMS_BUSINESS_UNIT.PHARMACY) {
      setEpharmacyPage(true);
    }
  }, [props?.screenName]);

  useEffect(() => {
    if (userLogin) {
      setIsGuest(false);
    } else {
      setIsGuest(true);
    }
  }, [userLogin]);

  const findTitleForUrl = (searchUrl) => {
    const category = suggestions?.find((category) => {
      return category?.suggestions?.some((suggestion) => suggestion?.url === searchUrl);
    });

    return category ? category?.title : null;
  };
  
  const highlightSuggestionItem = (searchWords, text) => (
    <Highlighter
      highlightTag={BoldSuggestion}
      highlightClassName="searchText"
      searchWords={searchWords}
      autoEscape
      textToHighlight={text !== undefined ? text : null}
    />
  );
  let result= new Set();
  let autosuggestion;
  const highlightSuggestion =(query, suggestion) => {
    let searchWords = [query];
    result.add(suggestion?.type);
    autosuggestion=Array.from(result);

    let matchingIndex = null;
    if (suggestion?.type === 'keywords' || suggestion?.type === 'brand' || suggestion?.type === 'keywords_in_category' || suggestion?.type === 'category' || suggestion?.type === 'products') {
      matchingIndex = suggestions[0]?.suggestions.findIndex(suggestion => suggestion?.title === suggestionObj?.title);
  } else if (suggestion?.type === 'practitioner' || suggestion?.type === 'speciality' || suggestion?.type === 'facility' || suggestion?.type === 'package') {
      matchingIndex = suggestions[1]?.suggestions.findIndex(suggestion => suggestion?.title === suggestionObj?.title);
  } else {
      matchingIndex = suggestions[2]?.suggestions.findIndex(suggestion => suggestion?.title === suggestionObj?.title);
  }
  
  if (matchingIndex !== -1) {
      setSuggestionposition(matchingIndex + 1);
  
  }

    const searchItem = {
      screen_name: getScreenName(),
      page_type: getPageType(),
      page_id: getPageId(),
      myaster_category: isEpharmacyPage
        ? 'epharmacy'
        : isTeleConsulation
        ? 'doctor consult'
        : isHomeCarePage
        ? 'homecare'
        : 'asco',
      search_term: value,
      keyword_selection: suggestionObj?.title,
      source_of_search: 'search bar - search suggestion',
      clicked_autosuggestion_type: suggestionObj?.type,
      search_category:
        suggestion?.type === 'keywords' ||
        suggestion?.type === 'brand' ||
        suggestion?.type === 'keywords_in_category' ||
        suggestion?.type === 'category' ||
        suggestion?.type === 'products'
          ? 'epharmacy'
          : suggestion?.type === 'practitioner' ||
            suggestion?.type === 'speciality' ||
            suggestion?.type === 'facility' ||
            suggestion?.type === 'package'
          ? 'doctor consult'
          : 'homecare',
      search_result_position: matchingIndex + 1,
      referrer_page:getreferrerPage() ,
    };

        const searchItemviewresult = {
          myaster_category:isEpharmacyPage
                  ? 'epharmacy'
                  : isTeleConsulation
                  ? 'doctor consult'
                  : isHomeCarePage
                  ? 'homecare'
                  : 'asco',
          search_term: value,
          source_of_search: "search bar - search suggestion",
          search_category:isEpharmacyPage
          ? 'epharmacy'
          : isTeleConsulation
          ? 'doctor consult'
          : isHomeCarePage
          ? 'homecare'
          : 'asco',
          referrer_page: getreferrerPage() ,
        }; 
    
    switch (suggestion?.type ? suggestion?.type : suggestion?.pageType) {
      case 'keywords':
        if (suggestion?.title) {
          const title = suggestion?.title || '';
          return (
            <div className="box p-0 borderBottomRadius">
              <div className="individual-container">
                <div className="epharmacy">
                  <div
                    className="box p-0 borderBottomRadius search-box-global epharmacy"
                    onClick={() => {
                      if (suggestion?.url) {
                        const searchUrl = suggestion?.url;
                        const titleName = findTitleForUrl(searchUrl);
                        let baseUrl = '';
                        if (titleName === 'Consult a Doctor') {
                          baseUrl = TELECONSULT_ROUTE;
                        } else if (titleName === 'Pharmacy') {
                          baseUrl = ONLINE_PHARMACY_ROUTE;
                        } else if (titleName === 'Home Care') {
                          baseUrl = HOME_CARE_ROUTE;
                        }
                        const encodedUrl = `${baseUrl}${suggestion?.url}&title=${encodeURIComponent(
                          suggestion?.title,
                        )}`;
                        router.push(generateURL(encodedUrl));
                        dataLayerSendEvent('search_result_item_click', searchItem);
                        dataLayerSendEvent('search_view_results', searchItemviewresult);
                      }
                    }}
                  >
                    <div className="keyword-container">
                      <Image
                        src={getImageUrlWithSize(suggestion?.imageUrl, 30, 30) || IC_SEARCH}
                        width={suggestion?.imageUrl ? 30 : 18}
                        height={suggestion?.imageUrl ? 30 : 18}
                        alt={suggestion?.title}
                        className="keyword-icon"
                        unoptimized
                      />
                      {isPomProductFlag && suggestion?.itemLabels?.includes(AE_GLOBAL?.RX) && (
                        <div
                          className='union-logo-container'
                        >
                          <Image src={IC_POM_DELIVERY_ICON_SEARCH} alt="UNION_LOGO" className="union-logo" width={12} height={12} />
                        </div>
                      )}
                      <div className="highlighted-text search-title individual-keyword-title">
                        {highlightSuggestionItem(searchWords, title.trim())}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        }
        return null;

      case 'brand':
        if (suggestion?.title) {
          const title = suggestion?.title || '';
          return (
            <div className="box p-0 borderBottomRadius">
              <div className="individual-container">
                <div className="epharmacy">
                  <div
                    className="box p-0 borderBottomRadius search-box-global epharmacy"
                    onClick={() => {
                      if (suggestion?.url) {
                        router.push({
                          pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/${suggestion?.url}`),
                        });
                        dataLayerSendEvent('search_result_item_click', searchItem);
                      }
                    }}
                  >
                    <div className="keyword-container">
                      <Image src={IC_SEARCH} width={18} height={18} alt={suggestion?.title} className="keyword-icon" />
                      <div className="highlighted-text search-title individual-keyword-title">
                        {highlightSuggestionItem(searchWords, title.trim())}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        }
        return null;

      case 'keywords_in_category':
        if (suggestion?.title) {
          const title = suggestion?.title || '';
          return (
            <div className="box p-0 borderBottomRadius">
              <div className="individual-container">
                <div className="epharmacy">
                  <div
                    className="box p-0 borderBottomRadius search-box-global epharmacy"
                    onClick={() => {
                      if (suggestion?.url) {
                        router.push({
                          pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/${suggestion?.url}&title=${encodeURIComponent(suggestion?.title)}`),
                        });
                        dataLayerSendEvent('search_result_item_click', searchItem);
                      }
                    }}
                  >
                    <div className="keyword-container">
                      <Image src={IC_SEARCH} width={18} height={18} alt={suggestion?.title} className="keyword-icon" />
                      {isPomProductFlag && suggestion?.itemLabels?.includes(AE_GLOBAL?.RX) && (
                        <div
                          className='union-logo-container'
                        >
                          <Image src={IC_POM_DELIVERY_ICON_SEARCH} alt="UNION_LOGO" className="union-logo" width={12} height={12} />
                        </div>
                      )}
                      <div className="highlighted-text search-title individual-keyword-title">
                        {highlightSuggestionItem(searchWords, title.trim())}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        }
        return null;

      case 'category':
        if (suggestion?.title) {
          const title = suggestion?.title || '';
          return (
            <div className="box p-0 borderBottomRadius">
              <div className="individual-container">
                <div className="epharmacy">
                  <div
                    className="box p-0 borderBottomRadius search-box-global epharmacy"
                    onClick={() => {
                      if (suggestion?.url) {
                        router.push({
                          pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/${suggestion?.url}&title=${encodeURIComponent(suggestion?.title)}`),
                        });
                        dataLayerSendEvent('search_result_item_click', searchItem);
                      }
                    }}
                  >
                    <div className="keyword-container">
                      <Image src={IC_SEARCH}  width={18} height={18} alt={suggestion?.title} className="keyword-icon" />
                      {isPomProductFlag && suggestion?.itemLabels?.includes(AE_GLOBAL?.RX) && (
                        <div
                          className='union-logo-container'
                        >
                          <Image src={IC_POM_DELIVERY_ICON_SEARCH} alt="UNION_LOGO" className="union-logo" width={12} height={12} />
                        </div>
                      )}
                      <div className="highlighted-text search-title individual-keyword-title">
                        {highlightSuggestionItem(searchWords, title.trim())}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        }
        return null;

      case 'products':
        if (suggestion?.title) {
          const title = suggestion?.title || '';
          return (
            <div className="box p-0 borderBottomRadius">
              <div className="individual-container">
                <div className="epharmacy">
                  <div
                    className="box p-0 borderBottomRadius search-box-global epharmacy"
                    onClick={() => {
                      if (suggestion?.url) {
                        router.push({
                          pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/${suggestion?.url}?fromsearch=true&title=${encodeURIComponent(suggestion?.title)}`),
                        });
                        dataLayerSendEvent('search_result_item_click', searchItem);
                      }
                    }}
                  >
                    <div className="product-container">
                      <div>
                      {suggestion?.imageUrl || suggestion?.thumbnailImage ? (
                        <img
                          src={suggestion?.imageUrl || suggestion?.thumbnailImage}
                          alt={suggestion?.title}
                          className="keyword-icon"
                        />
                      ) : (
                        <Image
                          src={IC_SEARCH}
                          width={18}
                          height={18}
                          alt={suggestion?.title}
                          className="keyword-icon"
                        />
                      )}
                      </div>
                      {isPomProductFlag && suggestion?.itemLabels?.includes(AE_GLOBAL?.RX) && (
                        <div
                          className='union-logo-container'
                        >
                          <Image src={IC_POM_DELIVERY_ICON_SEARCH} alt="UNION_LOGO" className="union-logo" width={12} height={12} />
                        </div>
                      )}
                      <div className="highlighted-text search-title individual-keyword-title">
                        {highlightSuggestionItem(searchWords, title.trim())}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        }

        return null;

      case 'practitioner':
        searchWords.push('Dr', 'Doctors');
        if (suggestion?.title) {
          const title = suggestion?.title || '';
          return (
            <div className="box p-0 borderBottomRadius">
              <div className="individual-container">
                <div className="epharmacy">
                  <div
                    className="box p-0 borderBottomRadius search-box-global epharmacy"
                    onClick={() => {
                      if (suggestion?.url) {
                        const encodedUrl = `${TELECONSULT_ROUTE}${suggestion?.url}?fromsearch=true&title=${encodeURIComponent(suggestion?.title)}`;
                        router.push(generateURL(encodedUrl));
                        dataLayerSendEvent('search_result_item_click', searchItem);
                      }
                    }}
                  >
                    <div className="product-container">
                      {suggestion?.imageUrl || suggestion?.thumbnailImage ? (
                        <img
                          src={suggestion?.imageUrl || suggestion?.thumbnailImage}
                          alt={suggestion?.title}
                          className="keyword-icon"
                        />
                      ) : (
                        <Image src={IC_SEARCH} width={18} height={18} alt={suggestion?.title} className="keyword-icon" />
                      )}
                      <div className="highlighted-text search-title individual-keyword-title">
                        {highlightSuggestionItem(searchWords, `${suggestion?.title} in ${suggestion?.subTitle}`)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        }
        return null;
      case 'speciality':
        if (suggestion?.title) {
          const title = suggestion?.title || '';
          return (
            <div className="box p-0 borderBottomRadius">
              <div className="individual-container">
                <div className="epharmacy">
                  <div
                    className="box p-0 borderBottomRadius search-box-global epharmacy"
                    onClick={() => {
                      if (suggestion?.url) {
                        const encodedUrl = `${TELECONSULT_ROUTE}${suggestion?.url}?fromsearch=true&title=${encodeURIComponent(suggestion?.title)}`;
                        router.push(generateURL(encodedUrl));
                        dataLayerSendEvent('search_view_results', searchItemviewresult);
                      }
                    }}
                  >
                    <div className="product-container">
                      {suggestion?.imageUrl || suggestion?.thumbnailImage ? (
                        <img
                          src={suggestion?.imageUrl || suggestion?.thumbnailImage}
                          alt={suggestion?.title}
                          className="keyword-icon"
                        />
                      ) : (
                        <Image src={IC_SEARCH} width={18} height={18} alt={suggestion?.title} className="keyword-icon" />
                      )}
                      <div className="highlighted-text search-title individual-keyword-title">
                        {highlightSuggestionItem(searchWords, `${suggestion?.title} in ${suggestion?.subTitle}`)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        }

        return null;

      case 'facility':
        searchWords.push(suggestion?.categoryName);
        if (suggestion?.title) {
          const title = suggestion?.title || '';
          return (
            <div className="box p-0 borderBottomRadius">
              <div className="individual-container">
                <div className="epharmacy">
                  <div
                    className="box p-0 borderBottomRadius search-box-global epharmacy"
                    onClick={() => {
                      if (suggestion?.url) {
                        const encodedUrl = `${TELECONSULT_ROUTE}${suggestion?.url}?fromsearch=true&title=${encodeURIComponent(suggestion?.title)}`;
                        router.push(generateURL(encodedUrl));
                        dataLayerSendEvent('search_result_item_click', searchItem);
                      }
                    }}
                  >
                    <div className="product-container">
                      {suggestion?.imageUrl || suggestion?.thumbnailImage ? (
                        <img
                          src={suggestion?.imageUrl || suggestion?.thumbnailImage}
                          alt={suggestion?.title}
                          className="keyword-icon"
                        />
                      ) : (
                        <Image src={IC_SEARCH} width={18} height={18} alt={suggestion?.title} className="keyword-icon" />
                      )}
                      <div className="highlighted-text search-title individual-keyword-title">
                        {highlightSuggestionItem(searchWords, `${suggestion?.title} in ${suggestion?.subTitle}`)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        }

        case 'package':
        searchWords.push(suggestion?.categoryName);
        if (suggestion?.title) {
          const title = suggestion?.title || '';
          return (
            <div className="box p-0 borderBottomRadius">
              <div className="individual-container">
                <div className="epharmacy">
                  <div
                    className="box p-0 borderBottomRadius search-box-global epharmacy"
                    onClick={() => {
                      if (suggestion?.url) {
                        const encodedUrl = `${TELECONSULT_ROUTE}${suggestion?.url}?fromsearch=true&title=${encodeURIComponent(suggestion?.title)}`;
                        router.push(generateURL(encodedUrl));
                        dataLayerSendEvent('search_result_item_click', searchItem);
                      }
                    }}
                  >
                    <div className="product-container">
                      {suggestion?.imageUrl || suggestion?.thumbnailImage ? (
                        <img
                          src={suggestion?.imageUrl || suggestion?.thumbnailImage}
                          alt={suggestion?.title}
                          className="keyword-icon"
                        />
                      ) : (
                        <Image src={IC_SEARCH} width={18} height={18} alt={suggestion?.title} className="keyword-icon" />
                      )}
                      <div className="highlighted-text search-title individual-keyword-title">
                        {highlightSuggestionItem(searchWords, `${suggestion?.title} in ${suggestion?.subTitle}`)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        }

        return null;
      case 'services':
        if (suggestion?.title) {
          const title = suggestion?.title || '';
          return (
            <div className="box p-0 borderBottomRadius">
              <div className="individual-container">
                <div className="epharmacy">
                  <div
                    className="box p-0 borderBottomRadius search-box-global epharmacy"
                    onClick={() => {
                      if (suggestion?.url) {
                        const encodedUrl = `${HOME_CARE_ROUTE}${suggestion?.url}?fromsearch=true&title=${encodeURIComponent(suggestion?.title)}`;
                        router.push(generateURL(encodedUrl));
                        dataLayerSendEvent('search_result_item_click', searchItem);
                      }
                    }}
                  >
                    <div className="product-container">
                      {suggestion?.imageUrl || suggestion?.thumbnailImage ? (
                        <img
                          src={suggestion?.imageUrl || suggestion?.thumbnailImage}
                          alt={suggestion?.title}
                          className="keyword-icon"
                        />
                      ) : (
                        <Image src={IC_SEARCH} width={18} height={18} alt={suggestion?.title} className="keyword-icon" />
                      )}
                      <div className="highlighted-text search-title individual-keyword-title">
                        {highlightSuggestionItem(searchWords, `${suggestion?.title} in ${suggestion?.subTitle}`)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        }

        return null;

      case 'packages':
        if (suggestion?.title) {
          const title = suggestion?.title || '';
          return (
            <div className="box p-0 borderBottomRadius">
              <div className="individual-container">
                <div className="epharmacy">
                  <div
                    className="box p-0 borderBottomRadius search-box-global epharmacy"
                    onClick={() => {
                      if (suggestion?.url) {
                        const encodedUrl = `${HOME_CARE_ROUTE}${suggestion?.url}?fromsearch=true&title=${encodeURIComponent(suggestion?.title)}`;
                        router.push(generateURL(encodedUrl));
                        dataLayerSendEvent('search_result_item_click', searchItem);
                      }
                    }}
                  >
                    <div className="product-container">
                      {suggestion?.imageUrl || suggestion?.thumbnailImage ? (
                        <img
                          src={suggestion?.imageUrl || suggestion?.thumbnailImage}
                          alt={suggestion?.title}
                          className="keyword-icon"
                        />
                      ) : (
                        <Image src={IC_SEARCH} width={18} height={18} alt={suggestion?.title} className="keyword-icon" />
                      )}
                      <div className="highlighted-text search-title individual-keyword-title">
                        {highlightSuggestionItem(searchWords, `${suggestion?.title} in ${suggestion?.subTitle}`)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        }

        return null;
      default:
        return highlightSuggestionItem(searchWords, suggestion?.name);
    }
  };

  const navigateToSpecificPage = (valueType, type) => {
    const { searchKeyword, categoryName, type: valueTypeType, moduleType, id, uriPath } = valueType;
    let matchingIndex = null;
    if (type==='Recent Search') {
        matchingIndex = recentSearchItems.findIndex(suggestion => suggestion?.searchKeyword === searchKeyword);
    } else {
        matchingIndex = trendingSearchItems.findIndex(suggestion => suggestion?.searchKeyword === searchKeyword);
    }
    
    if (matchingIndex !== -1) {
        setSuggestionposition(matchingIndex + 1);
    }

    if (props?.globalSearch || isEpharmacyPage || isTeleConsulation || isHomeCarePage) {
      const searchItem = {
        screen_name: getScreenName(),
        page_type: getPageType(),
        page_id: getPageId(),
        myaster_category: isEpharmacyPage
          ? 'epharmacy'
          : isTeleConsulation
          ? 'doctor consult'
          : isHomeCarePage
          ? 'homecare'
          : 'asco',
        search_term: null,
        keyword_selection: searchKeyword,
        clicked_autosuggestion_type: valueType?.type,
        search_category:
          valueType?.type === 'keywords' ||
          valueType?.type === 'brand' ||
          valueType?.type === 'keywords_in_category' ||
          valueType?.type === 'category' ||
          valueType?.type === 'products'
            ? 'epharmacy'
            : valueType?.type === 'practitioner' ||
              valueType?.type === 'speciality' ||
              valueType?.type === 'facility' ||
              valueType?.type === 'package'
            ? 'doctor consult'
            : 'homecare',
        source_of_search: type === 'Recent Search' ? 'search bar - recent search' : 'search bar - trending search',
        search_result_position: matchingIndex + 1,
        referrer_page: getreferrerPage() ,
      };
      dataLayerSendEvent('search_result_item_click', searchItem);
      const searchItemviewresult = {
        myaster_category: isEpharmacyPage
          ? 'epharmacy'
          : isTeleConsulation
          ? 'doctor consult'
          : isHomeCarePage
          ? 'homecare'
          : 'asco',
        search_term: searchKeyword,
        clicked_autosuggestion_type: valueType?.type,
        source_of_search: type === 'Recent Search' ? 'search bar - recent search' : 'search bar - trending search',
        search_category: isEpharmacyPage
          ? 'epharmacy'
          : isTeleConsulation
          ? 'doctor consult'
          : isHomeCarePage
          ? 'homecare'
          : 'asco',
        referrer_page: getreferrerPage() ,
      };
      dataLayerSendEvent('search_view_results', searchItemviewresult);
    }


    setSuggestions([]);

    if (valueTypeType === 'speciality') {
      triggerSearchtermApi(valueType, false, 'SUGGESTION');
      router.push({
        pathname: generateURL(`${TELECONSULT_ROUTE}/${uriPath}`),
        query: { type: 'home', search: searchKeyword },
      });
    } else if (valueTypeType === 'practitioner') {
      triggerSearchtermApi(valueType, false, 'SUGGESTION');
      sessionStorage.clear();
      sessionStorage.setItem('type', 'book');
      sessionStorage.setItem('referrerPage', 'SearchBar');
      const path = JSON.stringify(router);
      sessionStorage.setItem('backPath', path);
      router.push({
        pathname: generateURL(`${TELECONSULT_ROUTE}/${doctorNameEncoder(uriPath).replace(URL_QUERY, '')}`),
        query: { search: searchKeyword },
      });
    } else if (valueTypeType === 'facility') {
      triggerSearchtermApi(valueType, false, 'SUGGESTION');
      router.push({
        pathname: generateURL(`${TELECONSULT_ROUTE}/${uriPath.replace(URL_QUERY, '')}`),
        query: { type: 'home', search:searchKeyword },
      });
    } else if (moduleType === 'Epharmacy') {
      triggerSearchtermApi(valueType, false, 'SUGGESTION');
      router.push({
        pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/searchresult/`),
        query: { text: searchKeyword, catPath: valueType.searchFilterKey },
      });
    } else if (moduleType === 'HomeCare') {
      triggerSearchtermApi(valueType, false, 'SUGGESTION');
      const urlFormater = removeSpacesWithHyphen(searchKeyword);
      const queryParams = id ? { id } : { q: valueType.matching };

      router.push({
        pathname: generateURL(`${HOME_CARE_ROUTE}/searchresult/${urlFormater}`),
        query: queryParams,
      });
    } else if (moduleType === 'TeleConsultation') {
      triggerSearchtermApi(valueType, false, 'SUGGESTION');
      const urlFormater = removeSpacesWithHyphen(searchKeyword);
      const queryParams = id ? { id } : { q: valueType.matching };
      if (uriPath) {
        router.push({
          pathname: generateURL(`${TELECONSULT_ROUTE}/${uriPath}`),
          query: { type: 'home', search: searchKeyword },
        });
      } else {
        router.push({
          pathname: generateURL(`${TELECONSULT_ROUTE}/searchresult/${urlFormater}`),
          query: queryParams,
        });
      }
    }
  };

  const getPreFixClass = (type) =>
    ({
      background: 'search-box-label d-flex',
      arrow: 'ic-arrow right',
      view: 'search-view-blue cursor-pointer',
      hover: 'box p-0 borderBottomRadius search-box-global',
    }[type]);

  const getClassForTitle = (type, itm) =>
    ({
      Pharmacy: `${getPreFixClass(itm)} epharmacy`,
      'Consult a Doctor': getPreFixClass(itm),
      'Home Care': `${getPreFixClass(itm)} hc`,
    }[type]);

  const clearRecentSearch = () => {
    setLoading(true);
    const requestParams = 'Epharmacy';
    dispatch(
      apiActions.clearRecentSearch({
        requestParams: isEpharmacyPage ? requestParams : null,
        onSuccess: () => {
          setLoading(false);
          setRecentSearchItems(null);
        },
        onFailure: (err) => {
          setLoading(false);
          errorHandling(err, true);
        },
      }),
    );
  };

  const getSuggestionValue = (suggestion) => suggestion && suggestion.name;

  const renderSuggestion = (suggestion, { query }) => highlightSuggestion(query, suggestion);

  const renderSuggestionsContainer = ({ containerProps, children, query }) => {
    if (!noSuggestion) {
      if (query?.length > 2) {
        const newContainerProps = { className: `${containerProps.className} searchMenu` };
        const { ref, ...restContainerProps } = containerProps;
        const callRef = (isolatedScroll) => {
          if (isolatedScroll !== null) {
            ref(isolatedScroll.component);
          }
        };
        if (props?.globalSearch || isEpharmacyPage || isTeleConsulation || isHomeCarePage) {
          const newGlobalContainerProps = {
            ...containerProps,
            className: `${containerProps.className} searchMenu search-box-global-wrapper`,
          };

          return (
            <div {...newGlobalContainerProps}>
              <div>
                <div className="search-box-global-box">
                  <div className="box pt-1 pb-3">
                    <div className="searchLine">
                    {t('HeaderSearch.txtShowingResult')} <strong>{query}</strong>
                    </div>
                  </div>
                  <div className="box p-0 borderBottomRadius " id="search-box-global-wrapper">
                    <div className="divider" />
                    <div className="box p-0 borderBottomRadius">
                      <IsolatedScroll {...restContainerProps} className="epharmacy">
                        {children}
                      </IsolatedScroll>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        }
      }
      if (props?.globalSearch || isEpharmacyPage || isTeleConsulation || isHomeCarePage) {
        const newContainerProps = { ...containerProps, className: `${containerProps?.className} searchMenu` };
        return (
          <div {...newContainerProps}>
            {recentSearchItems && !isGuest && (
              <>
                <a
                  className="lnkClear"
                  onMouseDown={() => {
                    clearRecentSearch();
                  }}
                >
                  {t('HeaderSearch.clearAll')}
                </a>
                <div className="box pb-3">
                  <h3 className="title">{t('HeaderSearch.txtRecentSearches')}</h3>
                  <div className="tags">
                    {recentSearchItems?.map((search, key) => (
                      <a key={key} className="tag" onMouseDown={() => navigateToSpecificPage(search, 'Recent Search')}>
                        {search.searchKeyword}
                      </a>
                    ))}
                  </div>
                </div>
                <div className="divider" />
              </>
            )}

            <div className="box pb-0">
              <h3 className="title">{t('HeaderSearch.txtTrendingSearches')}</h3>
              <ul className="searchList">
                {(getIsInstoreApp()
                  ? trendingSearchItems?.filter((item) => item.moduleType === SCREEN_NAME?.AE)
                  : trendingSearchItems
                )?.map((search, key) => (
                  <li key={key} onMouseDown={() => navigateToSpecificPage(search, 'Trending Search')}>
                    <Link
                      href="javascript:void(0)"
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      <a>{search.searchKeyword}</a>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        );
      }
    }
  };

  const shouldRenderSuggestions = () => true;

  const onSuggestionsFetchRequested = (query) => {
    if (query?.value?.length > 2) {
      if (isEpharmacyPage) {
        dispatch(
          getGlobalSearchAutoSuggestion({
            queryParam: {
              q: query?.value,
              moduleType: 'Epharmacy',
            },
            onSuccess: (response) => {
              if (response) {
                const filteredResponse = Object.values(response).filter(item => item.moduleType === SCREEN_NAME?.AE);
                const searchResult = getIsInstoreApp() ? modifySuggestions(filteredResponse) : modifySuggestions(response);
                setNoSuggestion(false);
                result.add(searchResult?.type);
                autosuggestion = Array.from(result).slice(0, -1);
                setSuggestiotype(autosuggestion);
                setSuggestions(searchResult);
              }
              if (response) {
                setNoSuggestion(false);
              } else {
                setNoSuggestion(true);
              }
            },
            onFailure: (err) => {
              errorHandling(err, true);
            },
          }),
        );
      } else if (props?.globalSearch && !isTeleConsulation) {
        if (query?.value) {
          dispatch(
            getGlobalSearchAutoSuggestion({
              queryParam: { q: query?.value },
              onSuccess: (response) => {
                if (response) {
                  setNoSuggestion(false);
                  const searchResult = modifySuggestions(response);
                  result.add(searchResult?.type);
                  autosuggestion = Array.from(result).slice(0, -1);
                  setSuggestiotype(autosuggestion);
                  setSuggestions(searchResult);
                } else {
                  setNoSuggestion(true);
                }
              },
              onFailure: (e) => {
                errorHandling(e, true, screenName, pageType);
                console.log('🚀 ~ file: SearchBox.js:525 ~ onSuggestionsFetchRequested ~ e:', e);
              },
            }),
          );
        } else {
          setNoSuggestion(false);
          setSuggestions([{ suggestions: [{}] }]);
        }
      } else if (isTeleConsulation) {
        if (query?.value) {
          dispatch(
            getGlobalSearchAutoSuggestion({
              queryParam: {
                q: query?.value,
                moduleType: 'TeleConsultation',
              },
              onSuccess: (response) => {
                if (response) {
                  setNoSuggestion(false);
                  const searchResult = modifySuggestions(response);
                  setNoSuggestion(false);
                  result.add(searchResult?.type);
                  autosuggestion = Array.from(result).slice(0, -1);
                  setSuggestiotype(autosuggestion);
                  setSuggestions(searchResult);
                } else {
                  setNoSuggestion(true);
                }
              },
              onFailure: (err) => {
                errorHandling(err, true, screenName, pageType);
              },
            }),
          );
        } else {
          setNoSuggestion(false);
          setSuggestions([{ suggestions: [{}] }]);
        }
      } else if (isHomeCarePage) {
        if (query?.value) {
          dispatch(
            getGlobalSearchAutoSuggestion({
              queryParam: {
                q: query?.value,
                moduleType: 'HomeCare',
              },
              onSuccess: (response) => {
                if (response) {
                  const searchResult = modifySuggestions(response);
                  setNoSuggestion(false);
                  setSuggestions(searchResult);
                  result.add(searchResult?.type);
                  autosuggestion = Array.from(result).slice(0, -1);
                  setSuggestiotype(autosuggestion);
                } else {
                  setNoSuggestion(true);
                }
              },
              onFailure: (err) => {
                errorHandling(err, true);
              },
            }),
          );
        }
      } else if (query?.value && !isTeleConsulation) {
        dispatch(
          getGlobalSearchAutoSuggestion({
            queryParam: query?.value,
            onSuccess: (response) => {
              if (response) {
                setNoSuggestion(false);
              } else {
                setNoSuggestion(true);
              }
              setSuggestions(response);
            },

            onFailure: (err) => {
              errorHandling(err, true, screenName, pageType);
            },
          }),
        );
      } else {
        setNoSuggestion(false);
        setSuggestions([{}]);
      }
    }
  };

  const getSearchBody = (suggestion) => {
    const getTypeConfig = (moduleType, type) => ({
      searchKeyword: suggestion?.name || suggestion?.matching || suggestion?.searchKeyword,
      categoryName: suggestion?.categoryName,
      searchFilterKey: '',
      type,
      moduleType,
      specialization: suggestion?.specialization || '',
      id: suggestion?.id || '',
      uriPath: suggestion?.uriPath,
    });

    const lookup = {
      'category-pharmacy': getTypeConfig('Epharmacy', ''),
      PRODUCT_SEARCH: getTypeConfig('Epharmacy', ''),
      speciality: getTypeConfig('TeleConsultation', suggestion?.type),
      practitioner: getTypeConfig('TeleConsultation', suggestion?.type),
      facility: getTypeConfig('TeleConsultation', suggestion?.type),
      'category-homeCare': getTypeConfig('HomeCare', suggestion?.type),
      services: getTypeConfig('HomeCare', suggestion?.type),
      packages: getTypeConfig('HomeCare', suggestion?.type),
    };

    return lookup[suggestion?.type] || {};
  };

  useEffect(() => {
    if (value?.length > 2) {
      let parameter = {
        search_type: 'global_search',
      };
      if (router?.pathname?.indexOf(HOME_CARE_ROUTE) > -1) {
        parameter = {
          search_type: 'Homecare',
        };
      }
    }
  }, [value, router?.pathname]);

  const renderSectionTitle = (section) => {
    const { title } = section;
    const data = section.suggestions;
    const isPharmacyOrHomeCare =
      ['Pharmacy', 'Home Care', 'Consult a Doctor'].includes(title) && (data?.length > 1 || data?.length > 4);
    const isConsultDoctor = title === 'Consult a Doctor';
    const pharmacy_title = title === 'Pharmacy';
    const homecare_title = title === 'Home Care';
    const handleViewAllClick = () => {
      let pathname;
      const query = { [homecare_title ? 'q' : (isConsultDoctor ? 'search' : 'text')]: value?.replace(SEARCH_QUERY, '') };
      dataLayerSendEvent('search', {
        screen_name: getScreenName(),
        page_type: getPageType(),
        page_id: getPageId(),
        myaster_category: props?.globalSearch
          ? 'asco'
          : isEpharmacyPage
          ? 'epharmacy'
          : isTeleConsulation
          ? 'doctor consult'
          : isHomeCarePage
          ? 'homecare'
          : 'asco',
        search_term: value?.replace(SEARCH_QUERY, ''),
        search_action_type: 'view all link',
        displayed_autosuggestion_type: suggestiontype?.length > 0 ? suggestiontype : [],
        num_of_epharmacy_autosuggestions: suggestions[0]?.suggestions?.length ?? 0,
        num_of_doctor_consult_autosuggestions: suggestions[1]?.suggestions?.length ?? 0,
        num_of_homecare_autosuggestions: suggestions[2]?.suggestions?.length ?? 0,
        referrer_page: getreferrerPage() ,
      });
      if(suggestionObj===null){
        const searchItem = {
          myaster_category:isEpharmacyPage
                  ? 'epharmacy'
                  : isTeleConsulation
                  ? 'doctor consult'
                  : isHomeCarePage
                  ? 'homecare'
                  : 'asco',
          search_term: value,
          source_of_search:'search bar - view all',
          search_category:isEpharmacyPage
          ? 'epharmacy'
          : isTeleConsulation
          ? 'doctor consult'
          : isHomeCarePage
          ? 'homecare'
          : 'asco',
          referrer_page: getreferrerPage() ,
        };
      dataLayerSendEvent('search_view_results', searchItem); 
      }

      if (title === 'Pharmacy') {
        pathname = `${ONLINE_PHARMACY_ROUTE}/searchresult`;
      } else if (title === 'Home Care') {
        pathname = `${HOME_CARE_ROUTE}/searchresult`;
      } else if (isConsultDoctor) {
        pathname = `${TELECONSULT_ROUTE}/searchresult`;
        query.type = 'home';
      }

      router.push({
        pathname: generateURL(pathname),
        query,
      });

    };

    if (pharmacy_title && !props?.globalSearch && isEpharmacyPage) {
      return null;
    }
    if (isConsultDoctor && !props?.globalSearch && isTeleConsulation) {
      return null;
    }
    if (homecare_title && !props?.globalSearch && isHomeCarePage) {
      return null;
    }
    return (
      <>
        <div className={`${getClassForTitle(title, 'background')} ${isConsultDoctor ? 'consultDoctor' : ''}`}>
          {title}
          {isPharmacyOrHomeCare && (
            <div className={getClassForTitle(title, 'view')}>
              <div onMouseDown={handleViewAllClick}>{t('HeaderSearch.viewAll')}</div>
              <div className={getClassForTitle(title, 'arrow')} />
            </div>
          )}
        </div>
        <div className="section_divider" />
      </>
    );
  };

  function getSectionSuggestions(section) {
    if (section?.title === 'Pharmacy') {
      setModuleType('Epharmacy');
    } else {
      setModuleType('TeleConsultation');
    }
    return section && section?.suggestions;
  }

  const triggerSearchtermApi = (suggestion, isEmptySearch = false) => {
    let moduleType = '';
    const searchUrl = suggestion?.url;
    const titleName = findTitleForUrl(searchUrl);
    if (titleName === 'Consult a Doctor') {
      moduleType = 'TeleConsultation';
    } else if (titleName === 'Pharmacy') {
      moduleType = 'Epharmacy';
    } else if (titleName === 'Home Care') {
      moduleType = 'HomeCare';
    }
    const reqParams = {
      searchKeyword: suggestion?.title || value || suggestion?.searchKeyword,
      categoryName: suggestion?.categoryName || suggestion?.categoryName || '',
      searchFilterKey: suggestion?.searchFilterKey || '',
      type: suggestion?.type || suggestion?.pageType || '',
      moduleType: moduleType || suggestion?.moduleType || 'Epharmacy',
      specialization: suggestion?.specialization || '',
      id: suggestion?.id || suggestion?.categoryId || '',
      uriPath: suggestion?.url || suggestion?.uriPath || suggestion?.categoryPath || '',
      zone: localStorage.getItem('userZone'),
    };
  
    dispatch(
      searchTermInsertion({
        params: reqParams,
        onSuccess: (response) => {
          if (!isEmptySearch && suggestion?.id) {
            const params = {
              correlationId: response?.correlationId,
              clickedOn: product?.sku,
              clickType: suggestion?.clickType,
              type: response?.type,
              moduleType: moduleType,
            };
            dispatch(
              searchTermProductInsertion({
                params,
                onSuccess: (response) => {},
                onFailure: (err) => {
                  errorHandling(err, true);
                },
              }),
            );
          }
        },
        onFailure: (err) => {
          errorHandling(err, true);
        },
      }),
    );
  };

  const getSearchRedirectionUrl = async () => {
    const accessToken = await getGuestToken(deviceId);
    const context = {
      query: {
        text: value?.replace(SEARCH_QUERY, ''),
      },
    };
    const facetResponse = await fetchDataFromAPI(accessToken, deviceId, context, zoneData);
    return facetResponse?.redirectionUrl;
  };

  const onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
    event.preventDefault();
    inputRef?.blur();
    setValue('');
    if (props?.globalSearch) {
      triggerSearchtermApi(suggestion, false, 'GLOBAL_SUGGESTION');
    } else {
      triggerSearchtermApi(suggestion, false, 'SUGGESTION');
    }
    if (
      suggestion?.type === 'products' ||
      suggestion?.type === 'keywords' ||
      suggestion?.type === 'brand' ||
      suggestion?.type === 'keywords_in_category' ||
      suggestion?.type === 'category' ||
      suggestion?.type === 'category'
    ) {
      const searchUrl = suggestion?.url;
      const titleName = findTitleForUrl(searchUrl);
      let baseUrl = '';
      if (titleName === 'Consult a Doctor') {
        baseUrl = TELECONSULT_ROUTE;
      } else if (titleName === 'Pharmacy') {
        baseUrl = ONLINE_PHARMACY_ROUTE;
      } else if (titleName === 'Home Care') {
        baseUrl = HOME_CARE_ROUTE;
      }
      const constructedQuery = `${suggestion?.url?.split('?')[0]}?text=${suggestion?.title}`;
      const encodedUrl = encodeURI(`${baseUrl}${constructedQuery}&title=${suggestion?.title}`);
      router.push(generateURL(encodedUrl));
    } else if (suggestion?.type === 'category-pharmacy' || suggestion?.pageType === 'PRODUCT_SEARCH') {
      if (suggestion?.url) {
        router.push({
          pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/${suggestion?.url}?fromsearch=true&title=${encodeURIComponent(suggestion?.title)}`),
        });
      } else {
        router.push({
          pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/${suggestion?.url}?fromsearch=true&title=${encodeURIComponent(suggestion?.title)}`),
        });
      }
    } else if (suggestion?.type === 'speciality') {
      const encodedUrl = generateURL(`${TELECONSULT_ROUTE}${suggestion?.url}?fromsearch=true&title=${encodeURIComponent(suggestion?.title)}`);
      router.push(encodedUrl);
    } else if (suggestion?.type === 'practitioner') {
      sessionStorage.clear();
      sessionStorage.setItem('type', 'book');
      sessionStorage.setItem('referrerPage', 'SearchBar');
      const path = JSON.stringify(router);
      sessionStorage.setItem('backPath', path);
      const encodedUrl = generateURL(`${TELECONSULT_ROUTE}${suggestion?.url}?fromsearch=true&title=${encodeURIComponent(suggestion?.title)}`);
      router.push(encodedUrl);
    } else if (suggestion?.type === 'facility') {
      const encodedUrl = generateURL(`${TELECONSULT_ROUTE}${suggestion?.url}?fromsearch=true&title=${encodeURIComponent(suggestion?.title)}`);
      router.push(encodedUrl);
    } else if (
      suggestion?.type === 'category-homeCare' ||
      suggestion?.type === 'services' ||
      suggestion?.type === 'packages'
    ) {
      if (suggestion?.id) {
        const encodedUrl = generateURL(`${HOME_CARE_ROUTE}${suggestion?.url}?fromsearch=true&title=${encodeURIComponent(suggestion?.title)}`);
        router.push(encodedUrl);
      } 
    }
  };

  const redirectToSearchResult = async () => {
    const title = suggestions?.map((item) => item?.title);
    const hasPharmacy = title?.includes('Pharmacy');
    const hasTeleconsultation = title?.includes('Consult a Doctor');
    const hasHomecare = title?.includes('Home Care');
    if(props?.screenName === 'Product Listing' ||props?.screenName === 'Product Listing Page' || props?.screenName === 'Doctor Listing Page' || props?.screenName === 'Clinic Detail Page'){
      const searchItem = {
        myaster_category:isEpharmacyPage
                ? 'epharmacy'
                : isTeleConsulation
                ? 'doctor consult'
                : isHomeCarePage
                ? 'homecare'
                : 'asco',
        search_term: value,
        source_of_search:'search bar - hit enter',
        search_category:isEpharmacyPage
        ? 'epharmacy'
        : isTeleConsulation
        ? 'doctor consult'
        : isHomeCarePage
        ? 'homecare'
        : 'asco',
        referrer_page: getreferrerPage() ,
      };
    dataLayerSendEvent('search_view_results', searchItem); 
    }
    if ((props?.globalSearch || isEpharmacyPage || isTeleConsulation || isHomeCarePage) && iskeydown) {      
      triggerSearchtermApi({}, true, 'SUGGESTION');
      const redirectionUrl = await getSearchRedirectionUrl();
      if (redirectionUrl && redirectionUrl !== '') {
        router.push({
          pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/${redirectionUrl}`),
          query: {search:value},
        });
      } else if (title[0] === 'Pharmacy') {
        router.push({
          pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/searchresult`),
          query: { text: value?.replace(SEARCH_QUERY, '') },
        });
      } else if (title[0]==='Consult a Doctor') {
        router.push({
          pathname: generateURL(`${TELECONSULT_ROUTE}/searchresult`),
          query: { type: 'home',search: value?.replace(SEARCH_QUERY, '') },
        });
      } else if (title[0]==='Home Care') {
        router.push({
          pathname: generateURL(`${HOME_CARE_ROUTE}/searchresult`),
          query: { q: value?.replace(SEARCH_QUERY, '') },
        });
      } else if (!title?.length > 0 && props?.globalSearch) {
        router.push({
          pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/searchresult`),
          query: { text: value?.replace(SEARCH_QUERY, '') },
        });
      } else if (!title?.length > 0 && isEpharmacyPage) {
        router.push({
          pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/searchresult`),
          query: { text: value?.replace(SEARCH_QUERY, '') },
        });
      } else if (!title?.length > 0 && isTeleConsulation) {
        router.push({
          pathname: generateURL(`${TELECONSULT_ROUTE}/searchresult`),
          query: { type: 'home',search: value?.replace(SEARCH_QUERY, '') },
        });
      } else if (!title?.length > 0 && isHomeCarePage) {
        router.push({
          pathname: generateURL(`${HOME_CARE_ROUTE}/searchresult`),
          query: { q: value?.replace(SEARCH_QUERY, '') },
        });
      }
    } else if (!title?.length > 0 && props?.globalSearch){
      router.push({
        pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/searchresult`),
        query: { text: value?.replace(SEARCH_QUERY, '') },
      });
    }

    if (value?.replace(SEARCH_QUERY, '') !== '' && isEpharmacyPage) {
      const redirectionUrl = await getSearchRedirectionUrl();
      if (redirectionUrl && redirectionUrl !== '') {
        router.push({
          pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/${redirectionUrl}`),
          query: {search:value},
        });
      } else if (suggestionObj?.url) {
        router.push(generateURL(suggestionurl));
      } else if(!hasTeleconsultation && !hasHomecare){
        router.push({
          pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/searchresult`),
          query: { text: value?.replace(SEARCH_QUERY, '') },
        });
      }
    } else if (value?.replace(SEARCH_QUERY, '') !== '' && isTeleConsulation){
      const redirectionUrl = await getSearchRedirectionUrl();

      if (redirectionUrl && redirectionUrl !== '') {
        router.push({
          pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/${redirectionUrl}`),
          query: {search:value},
        });
      } else if (suggestionObj?.url) {
        router.push(generateURL(suggestionurl));
      } else if(!hasPharmacy && !hasHomecare){
        router.push({
          pathname: generateURL(`${TELECONSULT_ROUTE}/searchresult`),
          query: { type: 'home',search: value?.replace(SEARCH_QUERY, '') },
        });
      }
    } else if (value?.replace(SEARCH_QUERY, '') !== '' && isHomeCarePage) {
      const redirectionUrl = await getSearchRedirectionUrl();
      if (redirectionUrl && redirectionUrl !== '') {
        router.push({
          pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/${redirectionUrl}`),
          query: {search:value},
        });
      } else if (suggestionObj?.url) {
        router.push(generateURL(suggestionurl));
      } else if(!hasPharmacy && !hasTeleconsultation){
        router.push({
          pathname: generateURL(`${HOME_CARE_ROUTE}/searchresult`),
          query: { q: value?.replace(SEARCH_QUERY, '') },
        });
      }
    }
  };
  const getPlaceHolder = () => {
    if (props?.globalSearch && !web_feature_flaging?.isKsaUser) {
      return t('HeaderSearch.placeHolderForGlobalSearch');
    }
    if (isEpharmacyPage) {
      return t('HeaderSearch.placeHolderForEPharmacySearch');
    }
    if (isHomeCarePage) {
      return t('HeaderSearch.placeHolderForHomeCareSearch');
    }
    return t('HeaderSearch.placeHolderForDefaultSearch');
  };
  const [activeSuggestion, setActiveSuggestion] = useState(0);

  const inputProps = {
    placeholder: getPlaceHolder(),
    value,
    onChange: (event, { newValue }) => {
      if (newValue?.length < 2 && !isEpharmacyPage && !isHomeCarePage) {
        setNoSuggestion(false);
        setCallRecentSearch(true);
        if (props?.globalSearch) {
          setSuggestions([{ suggestions: [{}] }]);
        } else {
          setSuggestions([{ suggestions: [{}] }]);
        }
      }
      
      if(newValue?.length>2 && triggersearchevent){
        setEnablekeystroke(false);
        dataLayerSendEvent('search', {
          screen_name: getScreenName(),
          page_type: getPageType(),
          page_id: getPageId(),
          myaster_category: props?.globalSearch
            ? 'asco'
            : isEpharmacyPage
            ? 'epharmacy'
            : isTeleConsulation
            ? 'doctor consult'
            : isHomeCarePage
            ? 'homecare'
            : undefined,
          search_term: newValue?.replace(SEARCH_QUERY, ''),
          search_action_type: 'keystroke',
          displayed_autosuggestion_type: suggestiontype?.length > 0 ? suggestiontype : [],
          num_of_epharmacy_autosuggestions: suggestions[0]?.suggestions?.length ?? 0,
          num_of_doctor_consult_autosuggestions: suggestions[1]?.suggestions?.length ?? 0,
          num_of_homecare_autosuggestions: suggestions[2]?.suggestions?.length ?? 0,
          referrer_page: getreferrerPage() ,
        });
      }
      setValue(newValue);
    },
    onKeyDown: (event) => {
      if(event.keyCode===8){
      setTriggersearchevent(false);
      } 
      if(event.keyCode>8){
        setTriggersearchevent(true);
        } 
      const onkeydowntrue=event.keyCode>=50;
      setIskeydown(onkeydowntrue);
      if (event.keyCode === 13) {
        if (isEpharmacyPage || isHomeCarePage || isTeleConsulation || props?.globalSearch) {
          if (!/^\s*$/.test(value) ) {
            inputRef?.blur();
            if(suggestions?.length===0) {
              sendNoResultEvents(value, props, isEpharmacyPage, isTeleConsulation, isHomeCarePage);
            }
            redirectToSearchResult();
            if(enablekeystroke){
            dataLayerSendEvent('search', {
              screen_name: getScreenName(),
              page_type: getPageType(),
              page_id: getPageId(),
              myaster_category: props?.globalSearch
                ? 'asco'
                : isEpharmacyPage
                ? 'epharmacy'
                : isTeleConsulation
                ? 'doctor consult'
                : isHomeCarePage
                ? 'homecare'
                : undefined,
              search_term: value?.replace(SEARCH_QUERY, ''),
              search_action_type: 'enter key',
              displayed_autosuggestion_type: suggestiontype?.length > 0 ? suggestiontype : [],
              num_of_epharmacy_autosuggestions: suggestions[0]?.suggestions?.length ?? 0,
              num_of_doctor_consult_autosuggestions: suggestions[1]?.suggestions?.length ?? 0,
              num_of_homecare_autosuggestions: suggestions[2]?.suggestions?.length ?? 0,
              referrer_page: getreferrerPage() ,
            });
          }
          if(suggestionObj?.type==="keywords" || suggestionObj?.type==="speciality"){
            const searchItem = {
              myaster_category:isEpharmacyPage
                      ? 'epharmacy'
                      : isTeleConsulation
                      ? 'doctor consult'
                      : isHomeCarePage
                      ? 'homecare'
                      : 'asco',
              search_term: value,
              source_of_search:'search bar - hit enter',
              search_category:isEpharmacyPage
              ? 'epharmacy'
              : isTeleConsulation
              ? 'doctor consult'
              : isHomeCarePage
              ? 'homecare'
              : 'asco',
              referrer_page: getreferrerPage() ,
            };
          dataLayerSendEvent('search_view_results', searchItem); 
          }
          }
        } else if (!props?.globalSearch && value?.length > 2 && suggestions?.length > 0) {
          router.push({
            pathname: generateURL(`${TELECONSULT_ROUTE}/searchresult`),
            query: { type: 'home', search: value },
          });
        }
      }
    },
    onBlur: (event) => {
      setValue('');
      event.preventDefault();
      setValue(suggestionObj?.title ?? event.target.value);
      setNoSuggestion(false);
    },
    onClick: (event) => {
      if (router?.route.includes('/online-pharmacy') || router?.route.includes('/doctor-consultation')) {
        dataLayerSendEvent('search_bar_click', {
            screen_name: getScreenName(),
            page_type: getPageType(),
            page_id: getPageId(),
            myaster_category: isEpharmacyPage
                ? 'epharmacy'
                : isTeleConsulation
                ? 'doctor consult'
                : isHomeCarePage
                ? 'homecare'
                : 'asco',
            num_of_recent_autosuggestions: recentSearchItems?.length ?? 0,
            num_of_trending_autosuggestions: trendingSearchItems?.length ?? 0,
            referrer_page: props?.referrerPage,
        });
    } else {
        dataLayerSendEvent('search_bar_click', {
            screen_name: getScreenName(),
            page_type: getPageType(),
            page_id: getPageId(),
            myaster_category: isEpharmacyPage
                ? 'epharmacy'
                : isTeleConsulation
                ? 'doctor consult'
                : isHomeCarePage
                ? 'homecare'
                : 'asco',
            num_of_recent_autosuggestions: recentSearchItems?.length ?? 0,
            num_of_trending_autosuggestions: trendingSearchItems?.length ?? 0,
        });
    }
    
      event.preventDefault();
      if (value?.length < 2) {
        if (isHomeCarePage) {
          setSuggestions([{ suggestions: [{}] }]);
        } else if (isEpharmacyPage || props?.globalSearch) {
          setSuggestions([{ suggestions: [{}] }]);
        } else {
          setSuggestions([{ suggestions: [{}] }]);
        }
        setCallRecentSearch(true);
        setNoSuggestion(false);
      }
    },
  };

  const onSuggestionHighlighted = ({ suggestion }) => {
    setSuggestionObj(suggestion);
    switch (suggestion?.type) {
      case 'keywords':
        if (suggestion?.url) {
          const encodedUrl = `${ONLINE_PHARMACY_ROUTE}${suggestion?.url}`;
          setSuggestionurl(encodedUrl);
        }
        return null;

      case 'brand':
      case 'keywords_in_category':
      case 'category':
      case 'products':
        if (suggestion?.url) {
          const url = `${ONLINE_PHARMACY_ROUTE}/${suggestion?.url}?fromsearch=true&title=${encodeURIComponent(suggestion?.title)}`;
          setSuggestionurl(url);
        }
        return null;

      case 'practitioner':
      case 'speciality':
      case 'facility':
      case 'package':
        if (suggestion?.url) {
          const encodedUrl = `${TELECONSULT_ROUTE}/${suggestion?.url}?fromsearch=true&title=${encodeURIComponent(suggestion?.title)}`;
          setSuggestionurl(encodedUrl);
        }
        return null;

      case 'services':
      case 'packages':
        if (suggestion?.url) {
          const encodedUrl = `${HOME_CARE_ROUTE}/${suggestion?.url}?fromsearch=true&title=${encodeURIComponent(suggestion?.title)}`;
          setSuggestionurl(encodedUrl);
        }
        return null;
    }
  };


  const getModule = () => {
    if (isEpharmacyPage) {
      return 'Epharmacy';
    }
    if (isHomeCarePage) {
      return 'HomeCare';
    }
    if (isTeleConsulation) {
      return 'TeleConsultation';
    }
    return null;
  };

  useEffect(() => {
    if (getDataFromCookieAToB('kcToken') || getDataFromCookie('Guest_Token')) {
      if (callRecentSearch) {
        if (userLogin) {
          dispatch(
            apiActions.getRecentAndTopTrendingSearch({
              onSuccess: () => {},
              onFailure: (err) => {
                errorHandling(err, true);
              },
            }),
          );
        }
        dispatch(
          apiActions.getTopTrendSearch({
            onSuccess: () => {},
            onFailure: (err) => {
              errorHandling(err, true);
            },
          }),
        );
        setCallRecentSearch(false);
      }
    }
  }, [callRecentSearch, dispatch, userLogin, guestLogin]);

  useEffect(() => {
    if (recentSearches?.length > 0) {
      setRecentSearchItems(recentSearches);
    } else {
      setRecentSearchItems(null);
    }
  }, [recentSearches]);

  useEffect(() => {
    if (trendingSearches?.length > 0) {
      setTrendingSearchItems(trendingSearches);
    } else {
      setTrendingSearchItems(null);
    }
  }, [trendingSearches]);

  return (
    <>
      <Loader isLoading={loading} />
      <SearchBoxStyled isEpharmacyPage={isEpharmacyPage}n className={currentLang && isRTL(currentLang) ? 'rtl' : ''}>
        <Autosuggest
          ref={(autosuggest) => {
            if (autosuggest !== null) {
              inputRef = autosuggest.input;
            }
          }}
          suggestions={suggestions?.length > 0 ? suggestions : []}
          onSuggestionsFetchRequested={onSuggestionsFetchRequested}
          getSuggestionValue={getSuggestionValue}
          renderSuggestion={renderSuggestion}
          renderSuggestionsContainer={renderSuggestionsContainer}
          shouldRenderSuggestions={shouldRenderSuggestions}
          onSuggestionsClearRequested={() => {}}
          onSuggestionSelected={onSuggestionSelected}
          inputProps={inputProps}
          focusInputOnSuggestionClick={false}
          multiSection={true}
          renderSectionTitle={renderSectionTitle}
          getSectionSuggestions={getSectionSuggestions}
          onSuggestionHighlighted={onSuggestionHighlighted}
        />
        {value?.length > 0 && value?.length <= 2 && !isEpharmacyPage && value && showMinCharPopup && (
          <div className="searchMenu">
            <div className="noData">
              <div className="ic">
                <Image src={IC_SEARCH_NODATA} alt="IC_SEARCH_NODATA" />
              </div>
              <div className="details">
                <div className="title">
                  {value?.length <= 2 && !isEpharmacyPage
                    ? t('HeaderSearch.enterMinThreeChars')
                    : t('HeaderSearch.noResultsFound')}
                </div>
                <div className="description">
                  {value?.length <= 2 && !isEpharmacyPage
                    ? t('HeaderSearch.enterMoreChars')
                    : t('HeaderSearch.notFindMatchingSearch')}
                </div>
              </div>
            </div>
          </div>
        )}
        <div className={props?.globalSearch || isHomeCarePage ? 'icGlobalSearch' : 'icSearch'}>
          <Image
            src={IC_SEARCH}
            alt="Search Icon"
            data-test="redirectToSearch"
            priority
            onClick={() => {
              if (props?.globalSearch || isEpharmacyPage || isHomeCarePage || isTeleConsulation) {
                redirectToSearchResult();
              } else if (!props?.globalSearch && value?.length > 2) {
                redirectToSearchResult();
              }
              if(suggestions?.length===0){
                sendNoResultsEventsicon(value, props, isEpharmacyPage, isTeleConsulation, isHomeCarePage);
              }
              if (props?.globalSearch || isEpharmacyPage || isHomeCarePage || isTeleConsulation) {
                dataLayerSendEvent('search', {
                  screen_name: getScreenName(),
                  page_type: getPageType(),
                  page_id: getPageId(),
                  myaster_category: props?.globalSearch
                    ? 'asco'
                    : isEpharmacyPage
                    ? 'epharmacy'
                    : isTeleConsulation
                    ? 'doctor consult'
                    : isHomeCarePage
                    ? 'homecare'
                    : undefined,
                  search_term: value?.replace(SEARCH_QUERY, ''),
                  search_action_type: 'search icon click',
                  displayed_autosuggestion_type: suggestiontype?.length > 0 ? suggestiontype : [],
                  num_of_epharmacy_autosuggestions: suggestions[0]?.suggestions?.length ?? 0,
                  num_of_doctor_consult_autosuggestions: suggestions[1]?.suggestions?.length ?? 0,
                  num_of_homecare_autosuggestions: suggestions[2]?.suggestions?.length ?? 0,
                  referrer_page: getreferrerPage() ,
                });

                  const searchItem = {
                    myaster_category:isEpharmacyPage
                            ? 'epharmacy'
                            : isTeleConsulation
                            ? 'doctor consult'
                            : isHomeCarePage
                            ? 'homecare'
                            : 'asco',
                    search_term: value,
                    source_of_search:'search bar - search icon',
                    search_category:isEpharmacyPage
                    ? 'epharmacy'
                    : isTeleConsulation
                    ? 'doctor consult'
                    : isHomeCarePage
                    ? 'homecare'
                    : 'asco',
                    referrer_page: getreferrerPage() ,
                  };
                dataLayerSendEvent('search_view_results', searchItem); 
              }
            }}
          />
        </div>
        {(props?.globalSearch || isHomeCarePage) && value?.length > 2 && (
          <div
            className={props?.globalSearch ? 'icGlobalSearch icCrossSearch' : 'icSearch hcCrossSearch'}
            onClick={() => {
              setValue('');
            }}
          >
            <Image src={IC_MODAL_CLOSE_GREY} alt="Cross Icon" />
          </div>
        )}
      </SearchBoxStyled>
    </>
  );
};

SearchBox.defaultProps = {
  globalSearch: false,
};

SearchBox.propTypes = {
  children: PropTypes.object,
  title: PropTypes.string,
  globalSearch: PropTypes.bool,
  screenName: PropTypes.string,
};

export default SearchBox;
